module.exports = __webpack_public_path__ + "img/icon-scan-qrcode.5745d873.svg";